module.exports = __webpack_public_path__ + "static/360vr-1b8e920a41a26ca8e635bed234cd62bb.gif";